"use strict";

/*==============================================================================*
*TRESTLE™ W003
*FITNESS MANTRA DATA
*Version 1.0
*
*Contains all Fitness Mantra recommendations used by W003.
*No rendering logic.
*No DOM manipulation.
*==============================================================================*/

const TRESTLE_EXERCISE_DATA={

            balanced_life:{

                reproductive_years:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                    title:"Fitness Mantra",

                    intro:"Keep movement comfortable and flexible. Your energy may vary across your cycle, so choose activity that feels sustainable rather than demanding.",

                    morning:"Begin with 5–10 minutes of gentle stretching, mobility movements or a comfortable walk to ease into the day.",

                    midday:"Take a short walk after lunch or spend a few minutes away from your desk to break prolonged sitting.",

                    afternoon:"Use a brief movement break for shoulder rolls, neck stretches, ankle rotations or a few minutes of walking.",

                    beforeLeaving:"If comfortable, take a 10–15 minute walk or do light stretching before leaving work to transition out of the workday.",

                    advisory:"General educational guidance only. Adjust physical activity according to your comfort, energy and individual health needs."

                },

                planning_pregnancy:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                    title:"Fitness Mantra",

                    intro:"Regular moderate movement can be part of a balanced routine while preparing for pregnancy. Focus on consistency, mobility and activities you can comfortably sustain.",

                    morning:"Begin with gentle stretching, mobility exercises or a short walk to activate your body before the workday.",

                    midday:"Take a 10-minute walk after lunch where practical and avoid remaining seated continuously for long periods.",

                    afternoon:"Take a brief movement break with walking, shoulder mobility, calf raises or gentle stretches.",

                    beforeLeaving:"Choose a comfortable walk or light mobility routine before leaving work, especially after a largely sedentary day.",

                    advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

                },

                pregnant:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                    title:"Fitness Mantra",

                    intro:"Gentle, comfortable movement can support everyday wellbeing during pregnancy when physical activity is appropriate for you.",

                    morning:"Begin with gentle mobility or a short comfortable walk. Avoid movements that cause pain, dizziness or unusual discomfort.",

                    midday:"Take a brief comfortable walk after lunch and change sitting positions regularly during the workday.",

                    afternoon:"Use gentle shoulder, ankle and leg movements or a short walk to break prolonged sitting.",

                    beforeLeaving:"If comfortable, finish the workday with a gentle walk or simple mobility movements rather than strenuous activity.",

                    advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

                },

                postpartum:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Recovery comes first after childbirth. Gentle movement can gradually help rebuild mobility, strength and everyday energy as your body recovers.",

                morning:"Begin with gentle breathing, mobility or a short comfortable walk. Keep the intensity appropriate for your stage of recovery.",

                midday:"If comfortable, take a short easy walk after lunch and avoid remaining in one position for extended periods.",

                afternoon:"Use a brief movement break for gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking.",

                beforeLeaving:"Choose a gentle walk or light stretching if it feels comfortable. Avoid pushing through fatigue or discomfort.",

                advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

                    },

            perimenopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular movement can support strength, mobility and everyday energy through the menopausal transition. Combine walking with simple strength and mobility work where practical.",

                morning:"Start with 5–10 minutes of mobility, stretching or a brisk comfortable walk to get your body moving.",

                midday:"Take a 10-minute walk after lunch and break prolonged sitting whenever practical.",

                afternoon:"Use a short movement break for squats to a chair, calf raises, wall push-ups, shoulder mobility or walking.",

                beforeLeaving:"Take a comfortable 10–15 minute walk or complete a short strength and mobility routine before leaving work.",

                advisory:"General educational guidance only. Choose exercise appropriate for your fitness level and discuss new or strenuous activity with your healthcare professional when necessary."

            },

            menopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular movement, strength work and balance activities can support mobility, muscle strength and everyday independence after menopause.",

                morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements appropriate for your fitness level.",

                midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                beforeLeaving:"Choose a comfortable walk or a short combination of strength, balance and mobility exercises before leaving work.",

                advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Seek professional guidance when necessary."

            }
            
         }, 

         more_calmness:{

           reproductive_years:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Gentle movement can help create a physical pause during a busy workday. Choose comfortable activity that releases tension without adding pressure.",

                morning:"Begin with 5–10 minutes of gentle stretching, slow walking or mobility movements to ease into the day.",

                midday:"Take a short relaxed walk after lunch and use the time away from your desk as a mental and physical reset.",

                afternoon:"Pause for shoulder rolls, neck stretches, slow breathing and a few minutes of walking to release built-up tension.",

                beforeLeaving:"Finish with a comfortable 10-minute walk or gentle stretching to help transition away from work mode.",

                advisory:"General educational guidance only. Adjust movement according to your comfort, energy and individual health needs."

            },

            planning_pregnancy:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Regular moderate movement can provide a useful pause from mental demands while supporting a balanced routine when planning pregnancy.",

                morning:"Start with gentle mobility, stretching or a comfortable walk before settling into your workday.",

                midday:"Take a relaxed 10-minute walk after lunch and step away from your screen where practical.",

                afternoon:"Use a short movement break for shoulder mobility, gentle stretches, calf raises or a few minutes of walking.",

                beforeLeaving:"Choose a comfortable walk or light mobility routine to release physical tension accumulated during the workday.",

                advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

            },

            pregnant:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                    title:"Fitness Mantra",

                    intro:"Comfortable movement and regular breaks from sitting can provide gentle physical relief during a demanding workday when activity is appropriate for your pregnancy.",

                    morning:"Begin with gentle mobility or a short comfortable walk, avoiding movements that cause pain, dizziness or unusual discomfort.",

                    midday:"Take a brief comfortable walk after lunch and change sitting positions regularly rather than remaining seated for long periods.",

                    afternoon:"Use gentle shoulder, ankle and leg movements, slow breathing or a short walk to ease physical tension.",

                    beforeLeaving:"If comfortable, finish with a gentle walk or simple mobility movements to transition out of the workday.",

                    advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

                },

                postpartum:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Gentle movement can support recovery and provide a calming break during the workday as your body gradually regains strength after childbirth.",

                morning:"Begin with gentle breathing, mobility or a short comfortable walk. Keep the intensity appropriate for your stage of recovery.",

                midday:"If comfortable, take a short easy walk after lunch and avoid staying in one position for extended periods.",

                afternoon:"Use a brief movement break for gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking.",

                beforeLeaving:"Choose a gentle walk or light stretching if it feels comfortable, and avoid pushing through fatigue or discomfort.",

                advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

            },

            perimenopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular movement can help release physical tension while supporting strength, mobility and everyday energy during the menopausal transition.",

                morning:"Start with 5–10 minutes of mobility, stretching or a comfortable walk to ease stiffness and settle into the day.",

                midday:"Take a short walk after lunch and use the time away from your desk as a physical and mental reset.",

                afternoon:"Use a brief movement break for shoulder mobility, calf raises, gentle chair squats or a few minutes of walking.",

                beforeLeaving:"Choose a comfortable 10–15 minute walk or a short mobility routine to help release accumulated tension from the workday.",

                advisory:"General educational guidance only. Choose activity appropriate for your fitness level and discuss new or strenuous exercise with your healthcare professional when necessary."

            },

            menopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular walking, strength and balance activities can support mobility and wellbeing while also providing a useful physical reset during the workday.",

                morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements appropriate for your fitness level.",

                midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                beforeLeaving:"Choose a comfortable walk or a short combination of strength, balance and mobility exercises before leaving work.",

                advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Seek professional guidance when necessary."

            }



        }, 

        better_sleep:{

            reproductive_years:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Regular daytime movement can support a healthier sleep routine. Keep activity comfortable and use movement breaks to reduce long periods of sitting.",

                morning:"Begin with 5–10 minutes of stretching, mobility or a comfortable walk to gently activate your body for the day.",

                midday:"Take a short walk after lunch and spend a few minutes away from your desk where practical.",

                afternoon:"Use a brief movement break for shoulder rolls, neck stretches, calf raises or a few minutes of walking.",

                beforeLeaving:"Choose a comfortable 10–15 minute walk or gentle stretching to add some movement before your evening routine.",

                advisory:"General educational guidance only. Persistent sleep difficulties should be discussed with a qualified healthcare professional."

            },

            planning_pregnancy:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Consistent moderate movement during the day can support overall wellbeing and a regular sleep routine while planning pregnancy.",

                morning:"Start with gentle mobility, stretching or a comfortable walk to begin the day with some movement.",

                midday:"Take a short walk after lunch and avoid remaining seated continuously for long periods.",

                afternoon:"Use a brief movement break for walking, shoulder mobility, calf raises or gentle stretches.",

                beforeLeaving:"Choose a comfortable walk or light mobility routine before leaving work rather than leaving all your movement until late evening.",

                advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

            },

            pregnant:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                title:"Fitness Mantra",

                intro:"Gentle daytime movement and regular breaks from sitting can support comfort and everyday wellbeing during pregnancy when activity is appropriate for you.",

                morning:"Begin with gentle mobility or a short comfortable walk, avoiding movements that cause pain, dizziness or unusual discomfort.",

                midday:"Take a brief comfortable walk after lunch and change sitting positions regularly during the workday.",

                afternoon:"Use gentle shoulder, ankle and leg movements or a short walk to break prolonged sitting.",

                beforeLeaving:"If comfortable, finish the workday with a gentle walk or simple mobility movements rather than strenuous activity close to your evening routine.",

                advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

                }, 


        

            postpartum:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Gentle daytime movement can support recovery and help establish a healthier daily rhythm as your body adjusts after childbirth.",

                morning:"Begin with gentle breathing, mobility or a short comfortable walk, keeping the intensity appropriate for your stage of recovery.",

                midday:"If comfortable, take a short easy walk after lunch and avoid remaining in one position for extended periods.",

                afternoon:"Use a brief movement break for gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking.",

                beforeLeaving:"Choose a gentle walk or light stretching if comfortable. Keep movement restorative rather than exhausting, particularly when sleep has been disrupted.",

                advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

            },

            perimenopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular daytime movement can support physical wellbeing and a consistent sleep routine during the menopausal transition.",

                morning:"Start with 5–10 minutes of mobility, stretching or a comfortable walk to begin the day with some movement.",

                midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a brief movement break for chair squats, calf raises, shoulder mobility, stretching or a few minutes of walking.",

                beforeLeaving:"Choose a comfortable 10–15 minute walk or light strength and mobility routine before leaving work rather than postponing all activity until late evening.",

                advisory:"General educational guidance only. Persistent sleep difficulties during perimenopause should be discussed with a qualified healthcare professional."

            },

            menopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular walking, strength and balance activities can support overall wellbeing while daytime movement can contribute to a healthier daily sleep routine.",

                morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements appropriate for your fitness level.",

                midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                beforeLeaving:"Choose a comfortable walk or a short strength and mobility routine before leaving work, keeping strenuous activity away from your usual bedtime if it disrupts your sleep.",

                advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Persistent sleep problems should be discussed with a healthcare professional."

            }

        }, 

        more_energy:{

            reproductive_years:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Regular movement breaks can help reduce sluggishness and keep your body active through a largely seated workday.",

                morning:"Begin with 5–10 minutes of brisk walking, mobility or gentle bodyweight movements to get your body moving.",

                midday:"Take a 10-minute walk after lunch and avoid remaining seated continuously for long periods.",

                afternoon:"Use a short movement break for chair squats, calf raises, shoulder rolls or a few minutes of brisk walking.",

                beforeLeaving:"Choose a comfortable 10–15 minute walk or a short mobility routine to help you finish the workday actively.",

                advisory:"General educational guidance only. Persistent or unexplained fatigue should be discussed with a qualified healthcare professional."

            },

            planning_pregnancy:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Consistent moderate movement can support everyday energy and help reduce long periods of inactivity while planning pregnancy.",

                morning:"Start with gentle mobility, stretching or a comfortable brisk walk to activate your body before the workday.",

                midday:"Take a 10-minute walk after lunch and break prolonged sitting whenever practical.",

                afternoon:"Use a brief movement break for walking, calf raises, shoulder mobility or gentle bodyweight movements.",

                beforeLeaving:"Choose a comfortable walk or light mobility routine to add movement before transitioning into your evening.",

                advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

            },

            pregnant:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                title:"Fitness Mantra",

                intro:"Comfortable movement and regular breaks from sitting can help you remain active through the workday when physical activity is appropriate for your pregnancy.",

                morning:"Begin with gentle mobility or a short comfortable walk, avoiding movements that cause pain, dizziness or unusual discomfort.",

                midday:"Take a brief comfortable walk after lunch and change sitting positions regularly during the workday.",

                afternoon:"Use gentle shoulder, ankle and leg movements or a short walk to break prolonged sitting and physical sluggishness.",

                beforeLeaving:"If comfortable, finish the workday with a gentle walk or simple mobility movements without pushing through fatigue.",

                advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

            }, 

            postpartum:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                title:"Fitness Mantra",

                intro:"Gentle, regular movement can support recovery and help rebuild everyday energy gradually after childbirth.",

                morning:"Begin with gentle breathing, mobility or a short comfortable walk, keeping the intensity appropriate for your stage of recovery.",

                midday:"If comfortable, take a short easy walk after lunch and avoid remaining in one position for extended periods.",

                afternoon:"Use a brief movement break for gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking.",

                beforeLeaving:"Choose a gentle walk or light stretching if comfortable, without pushing through fatigue or discomfort.",

                advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

            },

            perimenopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Regular movement, simple strength work and frequent breaks from sitting can support everyday energy during the menopausal transition.",

                morning:"Start with 5–10 minutes of mobility, stretching or a comfortable brisk walk to activate your body.",

                midday:"Take a 10-minute walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a short movement break for chair squats, calf raises, wall push-ups, shoulder mobility or a few minutes of walking.",

                beforeLeaving:"Choose a comfortable 10–15 minute walk or a short strength and mobility routine before leaving work.",

                advisory:"General educational guidance only. Persistent or unexplained fatigue during perimenopause should be discussed with a qualified healthcare professional."

            },

            menopause:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                title:"Fitness Mantra",

                intro:"Walking, strength and balance activities can support mobility, muscle function and everyday energy after menopause.",

                morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements appropriate for your fitness level.",

                midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                beforeLeaving:"Choose a comfortable walk or a short combination of strength, balance and mobility exercises before leaving work.",

                advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Seek professional guidance when necessary."

            }


        }, 

                    better_focus:{

                reproductive_years:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                    title:"Fitness Mantra",

                    intro:"Short movement breaks can help interrupt long periods of sitting and provide a useful physical reset during mentally demanding work.",

                    morning:"Begin with 5–10 minutes of walking, stretching or mobility movements to activate your body before settling into focused work.",

                    midday:"Take a short walk after lunch and spend a few minutes away from your desk and screen where practical.",

                    afternoon:"Use a brief movement break for shoulder rolls, calf raises, gentle stretches or a few minutes of brisk walking before returning to work.",

                    beforeLeaving:"Choose a comfortable 10–15 minute walk or light mobility routine to help transition away from prolonged desk work.",

                    advisory:"General educational guidance only. Persistent difficulty with concentration or unexplained fatigue should be discussed with a qualified healthcare professional."

                },

                planning_pregnancy:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                    title:"Fitness Mantra",

                    intro:"Regular moderate movement and short breaks from sitting can provide useful physical resets during periods of concentrated work.",

                    morning:"Start with gentle mobility, stretching or a comfortable walk before beginning your workday.",

                    midday:"Take a 10-minute walk after lunch and step away from your screen where practical.",

                    afternoon:"Use a brief movement break for walking, shoulder mobility, calf raises or gentle stretches before returning to focused tasks.",

                    beforeLeaving:"Choose a comfortable walk or light mobility routine to break the physical pattern of a largely seated workday.",

                    advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

                },

                pregnant:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                    title:"Fitness Mantra",

                    intro:"Gentle movement and regular breaks from sitting can provide a physical reset during concentrated work when activity is appropriate for your pregnancy.",

                    morning:"Begin with gentle mobility or a short comfortable walk, avoiding movements that cause pain, dizziness or unusual discomfort.",

                    midday:"Take a brief comfortable walk after lunch and change sitting positions regularly during the workday.",

                    afternoon:"Use gentle shoulder, ankle and leg movements or a short walk as a break between periods of focused work.",

                    beforeLeaving:"If comfortable, finish the workday with a gentle walk or simple mobility movements without pushing through fatigue.",

                    advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

                }, 

                postpartum:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                    title:"Fitness Mantra",

                    intro:"Gentle movement breaks can provide a useful physical reset while your body recovers and you adjust to changing energy and concentration after childbirth.",

                    morning:"Begin with gentle breathing, mobility or a short comfortable walk, keeping the intensity appropriate for your stage of recovery.",

                    midday:"If comfortable, take a short easy walk after lunch and use the break to step away from your desk and screen.",

                    afternoon:"Use gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking between periods of focused work.",

                    beforeLeaving:"Choose a gentle walk or light stretching if comfortable, without pushing through fatigue or discomfort.",

                    advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

                },

                perimenopause:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                    title:"Fitness Mantra",

                    intro:"Regular movement and short activity breaks can provide useful physical resets during mentally demanding work while supporting mobility and everyday wellbeing.",

                    morning:"Start with 5–10 minutes of mobility, stretching or a comfortable walk before beginning concentrated work.",

                    midday:"Take a short walk after lunch and spend some time away from your desk and screen where practical.",

                    afternoon:"Use a brief movement break for chair squats, calf raises, shoulder mobility, gentle stretching or a few minutes of walking.",

                    beforeLeaving:"Choose a comfortable 10–15 minute walk or a short strength and mobility routine to transition away from prolonged desk work.",

                    advisory:"General educational guidance only. Persistent changes in concentration or unexplained fatigue during perimenopause should be discussed with a qualified healthcare professional."

                },

                menopause:{

                    image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                    title:"Fitness Mantra",

                    intro:"Walking, strength, balance and regular movement breaks can provide useful physical resets while supporting mobility and everyday wellbeing after menopause.",

                    morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements before settling into focused work.",

                    midday:"Take a short walk after lunch and regularly interrupt long periods of sitting and screen time.",

                    afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                    beforeLeaving:"Choose a comfortable walk or a short combination of strength, balance and mobility exercises to transition away from the workday.",

                    advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Persistent concentration difficulties should be discussed with a healthcare professional."

                }


           }, 


            healthier_living:{

                    reproductive_years:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                        title:"Fitness Mantra",

                        intro:"Build movement naturally into your workday with regular walking, mobility and simple strength activities rather than depending on one long exercise session.",

                        morning:"Begin with 5–10 minutes of walking, stretching or mobility movements to start the day actively.",

                        midday:"Take a 10-minute walk after lunch and break prolonged sitting whenever practical.",

                        afternoon:"Use a short movement break for chair squats, calf raises, shoulder rolls, gentle stretches or a few minutes of walking.",

                        beforeLeaving:"Choose a comfortable 10–15 minute walk or a short mobility and strength routine before leaving work.",

                        advisory:"General educational guidance only. Choose physical activity appropriate for your fitness level and individual health needs."

                    },

                    planning_pregnancy:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_woman_ex.webp?v=1786083639",

                        title:"Fitness Mantra",

                        intro:"Consistent moderate movement can form part of a healthy everyday routine while planning pregnancy. Focus on activities that are comfortable and sustainable.",

                        morning:"Start with gentle mobility, stretching or a comfortable walk to add movement before your workday begins.",

                        midday:"Take a 10-minute walk after lunch and avoid remaining seated continuously for long periods.",

                        afternoon:"Use a brief movement break for walking, calf raises, shoulder mobility or gentle bodyweight movements.",

                        beforeLeaving:"Choose a comfortable walk or light mobility routine to maintain regular movement through your day.",

                        advisory:"General educational guidance only. Discuss significant changes to your exercise routine with your healthcare professional when planning pregnancy."

                    },

                    pregnant:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/pregnant_ex.webp?v=1786161483",

                        title:"Fitness Mantra",

                        intro:"Regular comfortable movement and breaks from sitting can form part of a healthy workday during pregnancy when physical activity is appropriate for you.",

                        morning:"Begin with gentle mobility or a short comfortable walk, avoiding movements that cause pain, dizziness or unusual discomfort.",

                        midday:"Take a brief comfortable walk after lunch and change sitting positions regularly during the workday.",

                        afternoon:"Use gentle shoulder, ankle and leg movements or a short walk to break prolonged periods of sitting.",

                        beforeLeaving:"If comfortable, finish the workday with a gentle walk or simple mobility movements without pushing through fatigue.",

                        advisory:"General educational guidance only. Exercise during pregnancy should follow the advice of your obstetrician or qualified healthcare professional."

                    }, 

                postpartum:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/young_pospartun_woman_ex.webp?v=1786083639",

                        title:"Fitness Mantra",

                        intro:"Gentle, regular movement can support recovery and help rebuild everyday strength and mobility after childbirth.",

                        morning:"Begin with gentle breathing, mobility or a short comfortable walk, keeping the intensity appropriate for your stage of recovery.",

                        midday:"If comfortable, take a short easy walk after lunch and avoid remaining in one position for extended periods.",

                        afternoon:"Use a brief movement break for gentle shoulder, neck, ankle and back mobility or a few minutes of comfortable walking.",

                        beforeLeaving:"Choose a gentle walk or light stretching if comfortable, without pushing through fatigue or discomfort.",

                        advisory:"General educational guidance only. Return to exercise after childbirth should follow your healthcare professional's advice, particularly after complications or a caesarean birth."

                    },

                    perimenopause:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                        title:"Fitness Mantra",

                        intro:"Regular walking, mobility and simple strength work can support long-term health, muscle function and everyday wellbeing during the menopausal transition.",

                        morning:"Start with 5–10 minutes of mobility, stretching or a comfortable walk to begin the day actively.",

                        midday:"Take a 10-minute walk after lunch and regularly interrupt long periods of sitting.",

                        afternoon:"Use a short movement break for chair squats, calf raises, wall push-ups, shoulder mobility or a few minutes of walking.",

                        beforeLeaving:"Choose a comfortable 10–15 minute walk or a short strength and mobility routine before leaving work.",

                        advisory:"General educational guidance only. Choose activity appropriate for your fitness level and discuss new or strenuous exercise with your healthcare professional when necessary."

                    },

                    menopause:{

                        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/menopause_woman_ex.webp?v=1786083640",

                        title:"Fitness Mantra",

                        intro:"Regular walking, strength, balance and mobility work can support healthy ageing, muscle function and everyday independence after menopause.",

                        morning:"Begin with gentle mobility followed by a comfortable walk or simple strength movements appropriate for your fitness level.",

                        midday:"Take a short walk after lunch and regularly interrupt long periods of sitting.",

                        afternoon:"Use a brief movement break for chair squats, calf raises, wall push-ups, balance practice or gentle stretching.",

                        beforeLeaving:"Choose a comfortable walk or a short combination of strength, balance and mobility exercises before leaving work.",

                        advisory:"General educational guidance only. Exercise should be appropriate for your fitness, bone health and medical history. Seek professional guidance when necessary."

                    }


                }


  


};